import type { LiveRange } from "../api";

interface Props {
  value: LiveRange;
  onChange: (r: LiveRange) => void;
}

/**
 * 4-pill range picker for the Live chart. Stateless - the parent
 * owns the selected range so that range changes trigger a re-fetch
 * (the parent's effect depends on it).
 *
 * Keys are the same short strings the backend accepts (`15m`/`1h`/
 * `6h`/`24h`), so the value passes straight through to the URL.
 */
const OPTIONS: { value: LiveRange; label: string }[] = [
  { value: "15m", label: "15 min" },
  { value: "1h",  label: "1 uur" },
  { value: "6h",  label: "6 uur" },
  { value: "24h", label: "24 uur" },
];

export function RangeSelector({ value, onChange }: Props) {
  return (
    <div className="inline-flex bg-card-soft rounded-full p-1 border border-card-border">
      {OPTIONS.map((o) => {
        const active = o.value === value;
        return (
          <button
            key={o.value}
            type="button"
            onClick={() => onChange(o.value)}
            className={`px-3 py-1.5 text-xs rounded-full transition-all font-medium ${
              active
                ? "bg-card text-ink shadow-card"
                : "text-ink-mute hover:text-ink"
            }`}
          >
            {o.label}
          </button>
        );
      })}
    </div>
  );
}
